/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import { FacilityAvailableStatusCode } from '../../../packs/entites/FacilityInfo'
// note: sprite icon にすると表示が崩れたため、svgベタ書きで対応
import { BeforeAcceptanceSvg } from './marker_svg/BeforeAcceptanceSvg'
import { CongestionSvg } from './marker_svg/CongestionSvg'
import { EndAcceptanceSvg } from './marker_svg/EndAcceptanceSvg'
import { FullSvg } from './marker_svg/FullSvg'
import { HolidaySvg } from './marker_svg/HolidaySvg'
import { NotContractedSvg } from './marker_svg/NotContractedSvg'
import { VacanciesSvg } from './marker_svg/VacanciesSvg'

export type MapMarkerProps = {
  lat: number
  lng: number
  text: string
  statusCode: FacilityAvailableStatusCode
  onClick: VoidFunction
  selected: boolean
}

export const MapMarker = ({
  statusCode,
  onClick,
  selected,
}: MapMarkerProps) => {
  let MarkerSvgComponent
  switch (statusCode) {
    case 'before_acceptance':
      MarkerSvgComponent = BeforeAcceptanceSvg
      break
    case 'end_acceptance':
      MarkerSvgComponent = EndAcceptanceSvg
      break
    case 'holiday':
      MarkerSvgComponent = HolidaySvg
      break
    case 'vacancies':
      MarkerSvgComponent = VacanciesSvg
      break
    case 'vacancies_little':
      MarkerSvgComponent = CongestionSvg
      break
    case 'congestion':
    case 'full':
      MarkerSvgComponent = FullSvg
      break

    default:
      MarkerSvgComponent = NotContractedSvg
      break
  }

  return (
    <div
      css={css`
        position: relative;
      `}
      onClick={onClick}
      className="marker"
      style={{
        transform: selected ? 'scale(2)' : undefined,
      }}
    >
      <MarkerSvgComponent
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translateY(-85%) translateX(-50%)', // 85%上げると、マーカーのちょうど先端の辺りが施設の位置になる
          WebkitTransform: 'translateY(-50%) translateX(-50%)',
          margin: 'auto',
        }}
      />
    </div>
  )
}
